import {
  forceSimulation as d3_forceSimulation,
  forceLink as d3_forceLink,
  forceManyBody as d3_forceManyBody,
  forceCollide as d3_forceCollide,
  forceX as d3_forceX,
  forceY as d3_forceY,
} from 'd3-force'
import { quadtree as d3_quadtree } from 'd3-quadtree'
import { select as d3_select, select } from 'd3-selection'

export function layoutLabels(nodes, scale) {
  let anchors = []
  nodes.each(function (d) {
    anchors.push({
      id: 'anchor_' + d.id,
      node_id: d.id,
      fy: scale(d),
      fx: 0,
    })
  })
  nodes.each(function (d) {
    // if (!this.y) //RESETEAMOS CADA VEZ, que sino a veces quedaban "swapeados"
    this.y = scale(d)
    if (!this.fx) this.fx = 0
    this.id = d.id
    this.anchorRef = anchors.find(dd => dd.node_id === d.id)
    // console.log('node d', d), (this._currentY = Math.random())
  })
  let simNodes = nodes.nodes().concat(anchors)
  let simLinks = anchors.map(a => {
    return {
      id: 'link_' + a.node_id,
      source: a.id,
      target: a.node_id,
    }
  })

  // WARNIGN, UN POCO ARBITRARIO EL "RADIUS 10"
  const simulation = d3_forceSimulation(simNodes)
    .force(
      'collision',
      d3_forceCollide().radius(d => {
        if (d.id.indexOf('anchor') >= 0) return 0
        else return d.getBoundingClientRect().height / 2
      })
    )
    .force(
      'link',
      d3_forceLink(simLinks)
        .id(d => d.id)
        .distance(0)
    )
    .alphaDecay(0.1)

  simulation.tick(1000)
  return nodes
}

let outerCentroid = (d, radius) => {
  let angle = d.startAngle + (d.endAngle - d.startAngle) / 2 - Math.PI / 2
  return [Math.cos(angle) * radius, Math.sin(angle) * radius]
}

export function pieChartLabels(nodes, scale, radius) {
  let count = 0
  let total = nodes.size()
  nodes.each(function (d) {
    let oc = outerCentroid(d, radius)
    const sign = oc[0] > 0 ? 1 : -1
    const signY = oc[1] > 0 ? 1 : -1
    let boundingRect = { height: 0, width: 0 }
    let textNode = d3_select(this).select('text').node()
    let iconNode = d3_select(this).select('.icon').node()
    if (!!textNode) {
      let textBoundingClientRect = textNode.getBoundingClientRect()
      boundingRect.width += textBoundingClientRect.width
      boundingRect.height =
        boundingRect.height < textBoundingClientRect.height
          ? textBoundingClientRect.height
          : boundingRect.height
    }
    if (!!iconNode) {
      let iconBoundingClientRect = iconNode.getBoundingClientRect()
      boundingRect.width += iconBoundingClientRect.width
      boundingRect.height =
        boundingRect.height < iconBoundingClientRect.height
          ? iconBoundingClientRect.height + 4
          : boundingRect.height
    }

    //const boundingRect = this.getBoundingClientRect()
    d.width = 300
    d.height = boundingRect.height // / 2
    d.offset = [sign < 0 ? -d.width : 0, 0]
    let angle = d.startAngle + (d.endAngle - d.startAngle) / 2
    let quads = [
      [1, -1],
      [1, 1],
      [-1, 1],
      [-1, -1],
    ]
    let initialOffset = []
    switch ([sign, signY].toString()) {
      case quads[0].toString():
        //Primer quad
        initialOffset = outerCentroid(d, (total - count) * 40)
        break
      case quads[1].toString():
        //Segundo quad
        initialOffset = outerCentroid(d, count * 40)
        break
      case quads[2].toString():
        //Tercer quad
        initialOffset = outerCentroid(d, (total - count) * 40)
        break
      case quads[3].toString():
        //Cuarto quad
        initialOffset = outerCentroid(d, count * 40)
        break
    }
    /*
    const initialOffset =
      sign > 0 ? outerCentroid(d, (total - count) * 20) : outerCentroid(d, count * 20)
    */
    count++
    d.x = scale(d)[0] + initialOffset[0] + d.offset[0]
    d.y = scale(d)[1] + initialOffset[1] + d.offset[1]
    d.cx = scale(d)[0] + d.offset[0]
    d.cy = scale(d)[1] + d.offset[1]
  })

  const simulation = d3_forceSimulation(nodes.data())
    .force('collision', forceCollideRectangle())
    .force(
      'forceX',
      d3_forceX()
        .x(d => d.cx)
        .strength(0.2)
    )
    .force(
      'forceY',
      d3_forceY()
        .y(d => d.cy)
        .strength(0.2)
    )
    .alphaDecay(0.1)
  simulation.tick(1000)

  nodes.each(function (d) {
    d.x = d.x - d.offset[0]
    //d.y = d.y - d.offset[1]
  })
}

export function segmentedBarLabels(nodes) {
  let count = 0
  let total = nodes.size()
  nodes.each(function (d) {
    let boundingRect = { height: 0, width: 0 }
    let textNode = d3_select(this).select('text').node()
    let iconNode = d3_select(this).select('.icon').node()
    if (!!textNode) {
      let textBoundingClientRect = textNode.getBoundingClientRect()
      boundingRect.width += textBoundingClientRect.width
      boundingRect.height =
        boundingRect.height < textBoundingClientRect.height
          ? textBoundingClientRect.height
          : boundingRect.height
    }
    if (!!iconNode) {
      let iconBoundingClientRect = iconNode.getBoundingClientRect()
      boundingRect.width += iconBoundingClientRect.width
      boundingRect.height =
        boundingRect.height < iconBoundingClientRect.height
          ? iconBoundingClientRect.height + 4
          : boundingRect.height
    }

    //const boundingRect = this.getBoundingClientRect()
    d.width = boundingRect.width //300
    d.height = boundingRect.height // / 2

    count++
    d.x = 0
    d.y = 10
    d.cx = 0
    d.cy = 0
  })

  const simulation = d3_forceSimulation(nodes.data())
    .force('collision', forceCollideRectangle())
    .force(
      'forceY',
      d3_forceY()
        .y(d => d.cy)
        .strength(0.2)
    )
    .alphaDecay(0.1)

  simulation.tick(1000)
}

function forceCollideRectangle() {
  let nodes
  let padding = 0
  function force(alpha) {
    const quad = d3_quadtree(
      nodes,
      d => d.x,
      d => d.y
    )
    for (const d of nodes) {
      quad.visit((q, x1, y1, x2, y2) => {
        let updated = false
        if (q.data && q.data !== d) {
          let x = d.x - q.data.x,
            y = d.y - q.data.y + d.height / 2 - 5, // <-- un poco arbitrario el 5, pero paso de "medir 1 line del text"...
            xSpacing = padding + (q.data.width + d.width) / 2,
            ySpacing = padding + (q.data.height + d.height) / 2,
            absX = Math.abs(x),
            absY = Math.abs(y),
            l,
            lx,
            ly

          if (absX < xSpacing && absY < ySpacing) {
            l = Math.sqrt(x * x + y * y)
            lx = (absX - xSpacing) / l
            ly = (absY - ySpacing) / l

            // the one that's barely within the bounds probably triggered the collision
            if (Math.abs(lx) > Math.abs(ly)) {
              lx = 0
            } else {
              ly = 0
            }
            d.x -= x *= lx
            d.x -= x *= lx
            d.y -= y *= ly
            q.data.x += x
            q.data.y += y

            updated = true
          }
        }
        return updated
      })
    }
  }

  force.initialize = _ => (nodes = _)

  return force
}

export function getCustomLineLabelHtml(config) {
  if (!config.showLineLabel) return null
  if (!!config.getLineLabelHtml) return config.getLineLabelHtml
  if (!config.lineLabelPreset || config.lineLabelPreset === 'default') return null
  switch (config.lineLabelPreset) {
    case 'lineDate':
      return function (d) {
        return `
              <div>
                <div style="color: ${this.color(d)}">${d.id}</div>
                <div>${this.formatValue(d.value[d.value.length - 1].id, 'x')}</div>
              </div>
              `
      }
    case 'lineValue':
      return function (d) {
        return `
              <div>
                <div style="color: ${this.color(d)}">${d.id}</div>
                <div>${this.formatValue(d.value[d.value.length - 1].value, 'y')}</div>
              </div>
              `
      }

    case 'lineDateValue':
      return function (d) {
        return `
              <div>
                <div style="color: ${this.color(d)}">${d.id}</div>
                </div>
                <div>
                  ${
                    this.formatValue(d.value[d.value.length - 1].id, 'x') +
                    ' (' +
                    this.formatValue(d.value[d.value.length - 1].value, 'y') +
                    ')'
                  }
                </div>
              </div>
              `
      }
  }
}
